import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postAppointment, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import './uti_template_date.scss';

export default function UtiTemplate(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [patientOne_UUId, setPatientOne_UUId] = useState('');
  let bmiValue = formData?.height && formData?.weight ? ((formData.weight / formData.height ** 2) * 10000).toFixed(2) : '';
  const handleChange = e => {
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    var text = e.target.value;

    if (e.target.name === 'patientId1') {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || '').trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            if (e.target.name === 'patientId1') {
              setPatientOne_UUId(data?.id);
              setFormData({
                ...formData,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId1') {
          setFormData({
            ...formData,
            patientId1: e.target.value
          });
        }
      }
    } else {
      console.log('Going in');
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const [pastHORows, setPastHORows] = useState([
    {
      condition: '',
      duration: '',
      medication: ''
    }
  ]);

  const handlePastHOValue = (ind, e) => {
    const {name, value} = e.target;
    const newRows = [...pastHORows];
    newRows[ind][name] = value;
    setPastHORows(newRows);
  };
  const pastHORowAdd = () => {
    setPastHORows([
      ...pastHORows,
      {
        condition: '',
        duration: '',
        medication: ''
      }
    ]);
  };
  const pastHORowRemove = i => {
    let newPast = pastHORows.filter((row, ind) => i !== ind);
    setPastHORows(newPast);
  };

  const [medRows, setMedRows] = useState([
    {
      sno: '',
      drug: '',
      dosage: '',
      frequency: '',
      relationshipwithfood: '',
      duration: ''
    }
  ]);

  const medRowAdd = () => {
    setMedRows([
      ...medRows,
      {
        sno: '',
        drug: '',
        dosage: '',
        frequency: '',
        relationshipwithfood: '',
        duration: ''
      }
    ]);
  };
  const medRowRemove = i => {
    let newPast = medRows.filter((row, ind) => i !== ind);
    setMedRows(newPast);
  };

  const handleMedValue = (ind, e) => {
    const {name, value} = e.target;
    const newRows = [...medRows];
    newRows[ind][name] = value;
    setMedRows(newRows);
  };
  const handlesubmit = () => {
    props.loaderchange('true');

    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById('utitemplateWrap').innerHTML;

          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'UTI Template Date'
            }
          };
          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment();
          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
            Swal.fire({
              title: 'Successful.',
              text: 'Record added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const {styleSec = {}, styleLabel = {}, styleSpan = {}} = options;

    return (
      <>
        <section style={{...styleSec, margin: '0 10px 10px 10px', display: 'flex'}}>
          <label
            style={{
              ...styleLabel,
              fontWeight: '600',
              marginRight: '5px',
              width: 'max-content'
            }}>
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };
  const renderTableTD = value => {
    return <td style={{border: '1px solid black', textAlign: 'center'}}>{value}</td>;
  };
  const renderTableTH = value => {
    return <th style={{border: '1px solid black', textAlign: 'center'}}>{value}</th>;
  };
  const renderDiscPoint = () => (
    <span
      style={{
        fontSize: '20px',
        // lineHeight: "20px",
        display: 'flex',
        alignItems: 'center',
        height: '20px'
      }}>
      ●
    </span>
  );

  return (
    <div id='UtiTemplate'>
      <div className='UtiTemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap:"3px"

            }}
          > */}
          {/* Patient ID and Couple ID (Side by side) */}
          {/* <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={formData.patientId1}
                  onChange={(e) => handleChange(e)}
                  name="patientId1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.patientId1}
                </span>
              </div>
            </div> */}

          {/* Patient Name */}
          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formData.patientName1}
                name="patientName1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;{formData.patientName1}
              </span>
            </div> */}
          {/* Gender and Blood Group (Side by side) */}
          {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={formData.gender1}
                  name="gender1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="" disabled selected>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.gender1}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formData.age1}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.age1}
              </span>
            </div> */}

          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center",
                // paddingLeft: "25px",
              }}
            >
              <span style={{ fontWeight: 600 }}>Blood Group</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                name="bloodGroup1"
                value={formData.bloodGroup1}
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <option value="" disabled selected>
                  Select Blood Group
                </option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bloodGroup1}
              </span>
            </div> */}
          {/* </div> */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              gap: '3px',
              backgroundColor: '#f7f7f7 ',
              borderRadius: '6px',
              padding: '16px 8px 16px 8px',
              gap: '3px'
            }}>
            <div style={{display: 'flex', gap: '16px', alignItems: 'center'}}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '125px 16px 250px',
                  alignItems: 'center '
                }}>
                <span style={{fontWeight: 600}}>Patient ID</span>
                <span style={{fontWeight: 600}}>: </span>
                <input
                  type='text'
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  value={props.patientsData.p_uhid}
                  onChange={e => handleChange(e)}
                  name='patientId'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px'
                  }}
                />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.p_uhid}</span>
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '125px 16px 250px',
                alignItems: 'center '
              }}>
              <span style={{fontWeight: 600}}>Patient Name</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name='patientName'
                style={{
                  border: '1px solid #ddd',
                  outline: 'none',
                  padding: '10px',
                  color: '#000'
                }}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`} style={{width: '100%'}}>
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px'
              }}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '125px 16px 250px',
                  alignItems: 'center '
                }}>
                <span style={{fontWeight: 600}}>Gender</span>
                <span style={{fontWeight: 600}}>: </span>
                <select
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  onChange={e => handleChange(e)}
                  value={props.patientsData.gender}
                  name='gender'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px',
                    backgroundColor: 'white'
                  }}>
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                  <option value='Others'>Others</option>
                  <option value='Decline to State'>Decline to State</option>
                </select>
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.gender}</span>
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '125px 16px 250px',
                alignItems: 'center '
              }}>
              <span style={{fontWeight: 600}}>Age</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={props.patientsData.age}
                name='age1'
                style={{
                  border: '1px solid #ddd',
                  outline: 'none',
                  padding: '10px'
                }}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.age}</span>
            </div>
          </div>
        </div>
        <div className='detail'>
          {/* <h2>
            UTI BLEEDING Template{" "}
            <span>
              Date{" "}
              <input
                type="date"
                className={`createTime ${show ? "hide" : "show"}`}
                name="date"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.date}
              </span>
            </span>
          </h2>
          <p>
            Name:{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="name"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.name}
            </span>
          </p>
          <p>
            Age:{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="age"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.age}
            </span>
          </p>
          <p>
            UHID (Should come automatically){" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="uhid"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.uhid}
            </span>
          </p>
          <p>
            Occupation{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="occupation"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.occupation}
            </span>
          </p> */}
          <p>
            C/O burning urination <input className={`createTime ${show ? 'hide' : 'show'}`} name='coburningurination' onChange={handleChange} />
            days/months
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.coburningurination}</span>
          </p>
          <p>
            C/o frequent urination{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='cofrequenturination' onChange={handleChange}>
              <option disabled selected>
                Select
              </option>

              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.cofrequenturination}</span>
          </p>
          <p>
            C/o painful intercourse{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='copainfulintercourse' onChange={handleChange}>
              <option disabled selected>
                Select
              </option>

              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.copainfulintercourse}</span>
          </p>
          <p>
            C/O discharge PV{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='codischargepv' onChange={handleChange}>
              <option disabled selected>
                Select
              </option>
              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.codischargepv}</span>
          </p>
          <p>
            C/O blood in urine{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='cobloodinurine' onChange={handleChange}>
              <option disabled selected>
                Select
              </option>
              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.cobloodinurine}</span>
          </p>
          <p>
            Others - <input className={`createTime ${show ? 'hide' : 'show'}`} name='others' onChange={handleChange} />
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.others}</span>
          </p>
          <br />
          <br />
          <p>
            Menstrual H/O <input className={`createTime ${show ? 'hide' : 'show'}`} name='menstrualho' onChange={handleChange} />
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.menstrualho}</span>
          </p>
          <p>
            LMP: <input type='date' className={`createTime ${show ? 'hide' : 'show'}`} name='lmp' onChange={handleChange} />
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.lmp}</span>
          </p>
          <p>
            Cycles:{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='cycles' onChange={handleChange}>
              <option disabled selected>
                Select
              </option>
              <option value='Regular'>Regular</option>
              <option value='Irregular'>Irregular</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.cycles}</span>
          </p>
          <p>
            Frequency: <input className={`createTime ${show ? 'hide' : 'show'}`} name='frequency' onChange={handleChange} />
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.frequency}</span>
          </p>
          <p>
            Pain during periods:{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='painduringperiods' onChange={handleChange}>
              <option disabled selected>
                Select
              </option>

              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.painduringperiods}</span>
          </p>
          <br />
          <br />
          <p>
            Obstetric h/o P L <input className={`createTime ${show ? 'hide' : 'show'}`} name='obstetrichoPL' onChange={handleChange} />
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.obstetrichoPL}</span>
          </p>
          <br />
          <p>Prev --- Vaginal delivery</p>
          <p>Prev --- Cesarean</p>
          <p>
            Sterilization{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='sterilization' onChange={handleChange}>
              <option disabled selected>
                Select
              </option>

              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.sterilization}</span>
          </p>
          <br />
        </div>
        <table className='table_1' border='1px' cellSpacing='0px'>
          <caption>Past H/O</caption>
          <tbody>
            <tr>
              <th>Condition</th>
              <th>Duration</th>
              <th>Medications</th>
              <th>Actions</th>
            </tr>
            {pastHORows.map((item, ind) => (
              <tr key={item}>
                <td>
                  <select name='condition' onChange={e => handlePastHOValue(ind, e)}>
                    <option selected disabled key=''>
                      Select
                    </option>
                    <option value='Diabetes' key=''>
                      Diabetes
                    </option>
                    <option value='Hypertension' key=''>
                      Hypertension
                    </option>
                    <option value='TB' key=''>
                      TB
                    </option>
                    <option value='Hypothyroid' key=''>
                      Hypothyroid
                    </option>
                    <option value='Hyperthyroid' key=''>
                      Hyperthyroid
                    </option>
                    <option value='Nil' key=''>
                      Nil
                    </option>
                    <option value='Others' key=''>
                      Others
                    </option>
                  </select>
                </td>
                <td>
                  <input className={`createTime ${show ? 'hide' : 'show'}`} name={`duration`} onChange={e => handlePastHOValue(ind, e)} />
                  <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData[`duration${item}`]}</span>
                </td>
                <td>
                  <input className={`createTime ${show ? 'hide' : 'show'}`} name={`medication`} onChange={e => handlePastHOValue(ind, e)} />
                  <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData[`medications${item}`]}</span>
                </td>
                <td>
                  {ind === 0 && <button onClick={e => pastHORowAdd()}>+</button>}
                  {ind !== 0 && <button onClick={e => pastHORowRemove(ind)}>-</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className='detail'>
          <p>
            On examination: <input className={`createTime ${show ? 'hide' : 'show'}`} name='onexamination' onChange={handleChange} />
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.onexamination}</span>
          </p>
          <p>
            GC Fair, Hydration - Adequate; <input name='hydration' onChange={handleChange} className={`createTime ${show ? 'hide' : 'show'}`} />
          </p>
          <p>
            BP - <input className={`createTime ${show ? 'hide' : 'show'}`} name='bp' onChange={handleChange} />
            mm/hg;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PR -{' '}
            <input className={`createTime ${show ? 'hide' : 'show'}`} name='pr' onChange={handleChange} />
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.bp}</span>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.pr}</span>
          </p>

          <p>
            Height: <input className={`createTime ${show ? 'hide' : 'show'}`} name='height' onChange={handleChange} /> m
          </p>
          <p>
            Weight: <input className={`createTime ${show ? 'hide' : 'show'}`} name='weight' onChange={handleChange} /> KGs
          </p>
          <p>
            BMI:
            <input type='text' name='bmi' className={`createTime ${show ? 'hide' : 'show'}`} value={bmiValue} />
            KG/m<sup style={{fontWeight: 'bold'}}>2</sup>
          </p>
          <p>
            Per abdomen: <input className={`createTime ${show ? 'hide' : 'show'}`} name='perabdomen' onChange={handleChange} />
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.perabdomen}</span>
          </p>
          <p>
            PS - <input className={`createTime ${show ? 'hide' : 'show'}`} name='ps' onChange={handleChange} />
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.ps}</span>
          </p>
          <p>
            PV - <input className={`createTime ${show ? 'hide' : 'show'}`} name='pv' onChange={handleChange} />
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.pv}</span>
          </p>
          <p>
            Pap Smear/HPV{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='papsmearhpv' onChange={handleChange}>
              <option disabled selected>
                Select
              </option>

              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.papsmearhpv}</span>
          </p>
          <p>
            Vaginal Swab{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='vaginalswab' onChange={handleChange}>
              <option disabled selected>
                Select
              </option>

              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.vaginalswab}</span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Lab:{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='lab' onChange={handleChange}>
              <option disabled selected>
                Select
              </option>

              <option value='Third eye'>Third eye</option>
              <option value='Karkinos'>Karkinos</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.lab}</span>
          </p>
          <p>
            Cervical cancer vaccine Advised{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='cervicalcancervaccine' onChange={handleChange}>
              <option disabled selected>
                Select
              </option>

              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.cervicalcancervaccine}</span>
          </p>
          <br />
          <br />
          <h2>Investigations</h2>
          <p>Urine RM,CS,FBS,HbA1C</p>
          <p>To start antibiotics after the culture report</p>
          <p>Complete full course of antibiotics</p>
        </div>
        <table className='table_1' border='1px' cellSpacing='0px'>
          <tbody>
            <tr>
              <th>Sno</th>
              <th>Drug </th>
              <th>Dosage NUMBERS</th>
              <th>Frequency</th>
              <th>Relationship with food</th>
              <th>Duration</th>
              <th>Actions</th>
            </tr>
            {medRows.map((item, i) => (
              <tr key={i}>
                <td>{i + 1}.</td>
                <td>
                  <input list='drugsList' name='drug' onChange={e => handleMedValue(i, e)} />
                  <datalist id='drugsList'>
                    <option value='SYP. CITRALKA/ALKASOL (Disodium Hydrogen Citrate 1.53gm/5ml)' key='' />
                    <option value='TAB. URISPAS (Flavoxate 200mg)' key='' />
                    <option value=' UTI FLUSH (Potassium, Magnesium Citrate, D-Mannose, Rosemary Extract, Cranberry Extract)' key='' />
                  </datalist>
                </td>
                <td>
                  <input className={`createTime ${show ? 'hide' : 'show'}`} name={`dosage`} onChange={e => handleMedValue(i, e)} />
                  <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData[`dosage${item}`]}</span>
                </td>
                <td>
                  <input className={`createTime ${show ? 'hide' : 'show'}`} name={`frequency`} onChange={e => handleMedValue(i, e)} />
                  <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData[`frequency${item}`]}</span>
                </td>
                <td>
                  <input className={`createTime ${show ? 'hide' : 'show'}`} name={`relationshipwithfood`} onChange={e => handleMedValue(i, e)} />
                  <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData[`relationwithfood`]}</span>
                </td>
                <td>
                  <input className={`createTime ${show ? 'hide' : 'show'}`} name={`duration`} onChange={e => handleMedValue(i, e)} />
                  <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData[`duration`]}</span>
                </td>
                <td style={{textAlign: 'center'}}>
                  {i == 0 && (
                    <button className={`${show ? 'hide' : 'show'}`} onClick={e => medRowAdd(i)}>
                      +
                    </button>
                  )}
                  {i > 0 && (
                    <button className={`${show ? 'hide' : 'show'}`} onClick={() => medRowRemove(i)}>
                      -
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className='detail'>
          <p>Tips</p>
        </div>
        <table className='table_1' border='1px' cellSpacing='0px'>
          <tbody>
            <tr>
              <th>Do's</th>
              <th>Dont's</th>
            </tr>
            <tr>
              <td>• Wipe/Use hand shower from front to back when you go to the toilet</td>
              <td>• Do not use soap</td>
            </tr>
            <tr>
              <td>• Keep the genital area clean and dry</td>
              <td>• Do not have lots of sugary food or drinks, as they may encourage bacteria to grow</td>
            </tr>
            <tr>
              <td>• Drink plenty of water</td>
              <td>• Do not wear tight synthetic underwear, leggings</td>
            </tr>
            <tr>
              <td>• Wash the skin around the vagina with water before and after intercourse</td>
              <td>
                <input className={`createTime ${show ? 'hide' : 'show'}`} name='dont4' onChange={handleChange} />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.dont4}</span>
              </td>
            </tr>
            <tr>
              <td>• Pass urine as soon as possible after intercourse</td>
              <td>
                <input className={`createTime ${show ? 'hide' : 'show'}`} name='dont5' onChange={handleChange} />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.dont5}</span>
              </td>
            </tr>
            <tr>
              <td>• Bend and try to fully empty your bladder</td>
              <td>
                <input className={`createTime ${show ? 'hide' : 'show'}`} name='dont6' onChange={handleChange} />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.dont6}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <p style={{fontWeight: '600'}}>
          NEXT APPOINTMENT -{' '}
          <input
            name='nextappointment'
            onChange={handleChange}
            type='datetime-local'
            // type="date"
          />
        </p>
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='utitemplate'>
        <div id='utitemplateWrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', marginBottom: '10px'}}>
            {renderReportfield('C/O burning urination :', formData.coburningurination)}
            {renderReportfield('C/o frequent urination  :', formData.cofrequenturination)}
            {renderReportfield('C/o painful intercourse:', formData.copainfulintercourse)}
            {renderReportfield('C/O discharge PV :', formData.codischargepv)}
          </div>
          <div style={{display: 'flex', marginBottom: '10px'}}>
            {renderReportfield('C/O blood in urine  :', formData.cobloodinurine)}
            {renderReportfield('Others :', formData.others)}
            {renderReportfield('LMP :', formData.lmp)}
            {renderReportfield('Cycles :', formData.cycles)}
            {renderReportfield('Frequency :', formData.frequency)}
          </div>
          <div style={{display: 'flex', marginBottom: '10px'}}>
            {renderReportfield('Pain during periods :', formData.painduringperiods)}
            {renderReportfield('Obstetric h/o P L :', formData.obstetrichoPL)}
            {renderReportfield('Sterilization :', formData.sterilization)}
          </div>
          <div>
            <table style={{width: '100%'}}>
              <caption style={{captionSide: 'top', fontWeight: '600'}}>Past H/O</caption>
              <thead>
                <tr>{['Condition', 'Duration', 'Medication'].map((ele, ind) => renderTableTH(ele))}</tr>
              </thead>
              <tbody>
                {pastHORows.map((ele, ind) => {
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele.condition)}
                      {renderTableTD(ele.duration)}
                      {renderTableTD(ele.medication)}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{display: 'flex', marginBottom: '10px'}}>
            {renderReportfield('On examination :', formData.onexamination)}
            {renderReportfield('GC Fair, Hydration - Adequate :', formData.hydration)}
            {renderReportfield('BP :', `${formData.bp ? formData.bp : '-'}  mm/hg`)}
            {renderReportfield('PR :', formData.pr)}
          </div>
          <div style={{display: 'flex', marginBottom: '10px'}}>
            {renderReportfield('Height :', `${formData.height ? formData.height : '-'} cm`)}
            {renderReportfield('Weight :', `${formData.weight ? formData.weight : '-'} KG`)}
            {renderReportfield('BMI :', `${bmiValue} KG/m2`)}
            {renderReportfield('PS :', formData.ps)}
          </div>
          <div style={{display: 'flex', marginBottom: '10px'}}>
            {renderReportfield('PV :', formData.pv)}
            {renderReportfield('Pap Smear/HPV :', formData.papsmearhpv)}
            {renderReportfield('Vaginal Swab :', formData.vaginalswab)}
            {renderReportfield('Lab :', formData.lab)}
            {renderReportfield('Cervical cancer vaccine Advised :', formData.cervicalcancervaccine)}
          </div>
          <div style={{display: 'block', marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>Investigations</h4>
            <h5 style={{fontWeight: 600, marginRight: '5px'}}>Urine RM,CS,FBS,HbA1C</h5>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>To start antibiotics after the culture report</h6>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>Complete full course of antibiotics</h6>
          </div>
          <div>
            <table style={{width: '100%'}}>
              <thead>
                <tr>{['S.NO', 'Drug', 'Dosage', 'Frequency', 'Relationship with food', 'Duration'].map(ele => renderTableTH(ele))}</tr>
              </thead>
              <tbody>
                {medRows.map((ele, i) => {
                  return (
                    <tr key={i}>
                      {renderTableTD(i + 1)}
                      {renderTableTD(ele.drug)}
                      {renderTableTD(ele.dosage)}
                      {renderTableTD(ele.frequency)}
                      {renderTableTD(ele.relationshipwithfood)}
                      {renderTableTD(ele.duration)}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{display: 'block', marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>Tips</h4>
          </div>
          <div>
            <table style={{width: '100%'}}>
              <thead>
                <tr>
                  {renderTableTH("Do's")}
                  {renderTableTH("Dont's")}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {renderTableTD('• Wipe/Use hand shower from front to back when you go to the toilet')}
                  {renderTableTD('• Do not use soap')}
                </tr>
                <tr>
                  {renderTableTD('• Keep the genital area clean and dry')}
                  {renderTableTD('• Do not have lots of sugary food or drinks, as they may encourage bacteria to grow')}
                </tr>
                <tr>
                  {renderTableTD('• Drink plenty of water')}
                  {renderTableTD('• Do not wear tight synthetic underwear, leggings')}
                </tr>
                <tr>
                  {renderTableTD('• Wash the skin around the vagina with water before and after intercourse')}
                  {renderTableTD(formData.dont4)}
                </tr>
                <tr>
                  {renderTableTD('• Pass urine as soon as possible after intercourse')}
                  {renderTableTD(formData.dont5)}
                </tr>
                <tr>
                  {renderTableTD('• Bend and try to fully empty your bladder')}
                  {renderTableTD(formData.dont6)}
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{display: 'flex', marginBottom: '10px'}}></div>

          <div style={{marginTop: '10px'}}>{renderReportfield('Next Appointment : ', appointmentData.date?.split('-').reverse().join('-'))}</div>
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
